var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":"Account Confirmation"}},[_c('h3',[_vm._v("Registration Submitted Successfully!")]),_c('br'),_c('p',[_vm._v("Your account is now being reviewed for approval!")]),_c('AccountIdCardContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }